// src/utils/getModelKey.js

const getModelKey = (manufacturer, model) => {
    if (!model) return "";
  
    const normalizedManufacturer = manufacturer ? manufacturer.trim().toLowerCase() : "";
    const words = model.trim().toLowerCase().split(/\s+/);
  
    let keyWords = words.slice(0, 2); // Standard: två första orden
    const fullModel = words.join(" "); // För att söka fraser
  
    if (fullModel.includes("pro max")) {
      const index = words.findIndex((word, i) => word === "pro" && words[i + 1] === "max");
      if (index !== -1) {
        keyWords = words.slice(0, index + 2);
      }
    } else if (words.includes("pro")) {
      const index = words.indexOf("pro");
      if (index !== -1) {
        keyWords = words.slice(0, index + 1);
      }
    }
    
  
    if (words[0] === "galaxy" && words[1] === "xcover") {
      keyWords = words.slice(0, 3);
    }
  
    if (
      words[0] === "surface" &&
      (words[1] === "laptop" || words[1] === "pro") &&
      words[2]
    ) {
      keyWords = words.slice(0, 3);
    }

    const modelKey = `${normalizedManufacturer} ${keyWords.join(" ")}`.trim();
    return modelKey.replace(/,/g, "");
  
  };
  
  export default getModelKey;
  